"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var AnswerStatus = /*#__PURE__*/function () {
  function AnswerStatus(questionStatus, emsId, isCorrect, answerText) {
    (0, _classCallCheck2["default"])(this, AnswerStatus);
    this.emsId = emsId;
    this.text = answerText; // this._checked = false;

    this.answerChecked = false; // this._questionStatus = questionStatus;

    this.questionStatus = questionStatus;
    this.correct = isCorrect;
  }

  (0, _createClass2["default"])(AnswerStatus, [{
    key: "showChecked",
    value: function showChecked() {
      // return this._checked || this.correct;
      return this.answerChecked || this.correct;
    }
  }, {
    key: "checked",
    set: function set(newValue) {
      if (typeof newValue !== 'undefined') {
        if (newValue) {
          // this._questionStatus._unsetChecksIfNonMultipleAllowed();
          this.questionStatus.unsetChecksIfNonMultipleAllowed();
        } // this._checked = newValue;


        this.answerChecked = newValue;
      } // return this._checked;


      return this.answerChecked;
    },
    get: function get() {
      // return this._checked;
      return this.answerChecked;
    }
  }]);
  return AnswerStatus;
}();

exports["default"] = AnswerStatus;